import campaignApi from "../apis/campaignApi";
import scheduledCampaignApi from "../apis/scheduledCampaignApi";
import moment from "moment";

export default {
    namespaced: true,
    state: {
        isLoading: false,
        campaigns: null,
    },
    getters: {
        campaignsLoaded(state) {
            return state.campaigns !== null;
        },
        getCampaignById: (state, getters) => (id, type = 'campaign') => {
            if (!getters.campaignsLoaded)
                return null;
            return state.campaigns.find(campaign => campaign.id === id && campaign.type === type);
            
        },
        getCampaignsForLanguage: (state, getters) => (language) => {
            if (!getters.campaignsLoaded) {
                return [];
            }
            return state.campaigns.filter(campaign => {
                let notification = getters.getNotification(campaign, language);
                return notification !== undefined;
            });
        },
        getNotification: (state) => (campaign, language) => {
            if (!campaign.notifications) {
                return {isActive: false};
            }
            return campaign.notifications.find(notification => {
                return notification.language === language;
            });
        },
        filterByApp: () => (campaigns, app) => {
            return campaigns.filter(campaign => {
                return campaign.apps.find(listedApp => listedApp.id === app) !== undefined;
            });
        },
        filterByLanguage: () => (campaigns, language) => {
            return campaigns.filter(campaign => {
                return campaign.notifications.find(notification => notification.language === language) !== undefined;
            });
        },
        filterByType: () => (campaigns, type) => {
            return campaigns.filter(campaign => {
                return campaign.notifications.find(notification => notification.type === type) !== undefined;
            });
        },
        filterCampaigns: (state, getters) => (language, apps, types) => {
            if (!getters.campaignsLoaded)
                return [];

            const notificationLanguageFilter = (language) => notification => notification.language === language;
            const appIdsFilter = (appIds) => app => apps.includes(app.id);
            const notificationTypesFilter = (types) => notification => types.includes(notification.type);

            return state.campaigns.filter(campaign => {
                return campaign.notifications.filter(notificationLanguageFilter(language)).length > 0
                    && campaign.apps.filter(appIdsFilter(apps)).length > 0
                    && campaign.notifications.filter(notificationTypesFilter(types)).length > 0;
            });

        }
    },
    mutations: {
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading;
        },
        setCampaigns(state, campaigns) {
            state.campaigns = campaigns;
        },
        addCampaign(state, campaign) {
            state.campaigns.unshift(campaign);
        },
        removeCampaign(state, campaign) {
            state.campaigns = state.campaigns.filter(c => {
                return !(c.id === campaign.id && c.type === campaign.type);
            });
        }
    },
    actions: {
        loadCampaigns({commit}) {
            commit('setIsLoading', true);

            return Promise.all([
                campaignApi.index(),
                scheduledCampaignApi.index()
            ])
                .then(lists => {
                    let campaings = [];
                    lists.forEach(list => {
                        campaings = campaings.concat(list);
                    });
                    campaings.sort((a, b) => {
                        let getDate = (campaign) => campaign.type === 'campaign'
                            ? moment(campaign.created_at)
                            : moment(campaign.schedule);

                        return getDate(b).valueOf() - getDate(a).valueOf();
                    });
                    commit('setCampaigns', campaings);
                })
                .finally(() => {
                    commit('setIsLoading', false);
                });
        },
        createCampaign({commit}, campaigns) {
            commit('setIsLoading', true);

            return campaignApi.store(campaigns)
                .then(campaign => {
                    commit('addCampaign', campaign);
                    return campaign;
                })
                .finally(() => {
                    commit('setIsLoading', false);
                });
        },
        deleteCampaign({commit}, campaign) {
            commit('setIsLoading', true);

            if (campaign.type === 'queued_job') {
                return scheduledCampaignApi.destroy(campaign.id)
                    .then(campaign => {
                        commit('removeCampaign', campaign);
                    })
                    .finally(() => {
                        commit('setIsLoading', false);
                    });
            } else if (campaign.type === 'campaign') {
                return campaignApi.destroy(campaign.id)
                    .then(campaign => {
                        commit('removeCampaign', campaign);
                        return campaign;
                    })
                    .finally(() => {
                        commit('setIsLoading', false);
                    });
            }
        }
    }
}
